export function getAccessToken() {
  let token = "";
  if (localStorage) {
    token = localStorage.getItem("login-access-token");
  }
  return token;
}


export function clearAccessToken() {
  //Clear cookie
  document.cookie = "columnis_token=;path=/";
  //Clear access token
  localStorage.removeItem('login-access-token');
  localStorage.removeItem('login-state');
}